import Vue from 'vue'

import c from './constants.js'

window.axios = require('axios')
window.axios.defaults.headers.common['Accept'] = 'application/json'
window.axios.defaults.baseURL = c.APIBASEURL

window.ajaxR = new XMLHttpRequest();

window.eventHub = new Vue()

window.ajax = {
    //error callback function
    throwErrorCallback(error) {
        console.log(error)
    },
    unauthorized(error) {
        eventHub.$emit('unauthorized')
        localStorage.clear();
        location.href = "/";
    },
    setAuthorization() {
        let userObj = JSON.parse(localStorage.getItem('homecare_admin_auth'))
        if (userObj == null || !userObj.access_token) {
            delete window.axios.defaults.headers.common['Authorization']
        } else {
            window.axios.defaults.headers.common['Authorization'] = `Token ${userObj.access_token}`
        }
    },
    //get method
    get(url, successCallBack, errorCallBack) {
        this.setAuthorization()
        var that = this;
        axios({
                method: 'get',
                url: url,
                async: false,
                responseType: 'json'
            })
            .then((response) => {
                successCallBack(response)
            })
            .catch((error) => {
                if (error && error.response && error.response.status != '401') {
                    if (typeof errorCallBack === 'undefined')
                        that.throwErrorCallback(error.response)
                    else
                        errorCallBack(error.response)
                } else {
                    if(error.response){
                        that.unauthorized()
                    }
                }
            })
    },
    post(url, data, successCallBack, errorCallBack) {
        this.setAuthorization()
        var that = this;
        axios({
                method: 'post',
                url: url,
                async: false,
                data: data,
                responseType: 'json'
            })
            .then((response) => {
                successCallBack(response)
            })
            .catch((error) => {
                if (error && error.response && error.response.status != '401') {
                    if (typeof errorCallBack === 'undefined')
                        that.throwErrorCallback(error.response)
                    else
                        errorCallBack(error.response)
                } else {
                    if(error){
                        that.unauthorized()
                    }
                }
            })
    },
    put(url, data, successCallBack, errorCallBack) {
        this.setAuthorization()
        var that = this;

        axios({
                method: 'put',
                url: url,
                data: data,
                responseType: 'json'
            })
            .then((response) => {
                successCallBack(response)
            })
            .catch((error) => {
                if (error.response.status != '401') {
                    if (typeof errorCallBack === 'undefined')
                        that.throwErrorCallback(error.response)
                    else
                        errorCallBack(error.response)
                } else {
                    that.unauthorized()
                }
            })
    },
    delete(url, data, successCallBack, errorCallBack) {
        this.setAuthorization()
        var that = this;

        axios({
                method: 'delete',
                url: url,
                data: data,
                responseType: 'json'
            })
            .then((response) => {
                successCallBack(response)
            })
            .catch((error) => {
                if (error.response.status != '401') {
                    if (typeof errorCallBack === 'undefined')
                        that.throwErrorCallback(error.response)
                    else
                        errorCallBack(error.response)
                } else {
                    that.unauthorized()
                }
            })
    },
    patch(url, data, successCallBack, errorCallBack) {
        this.setAuthorization()
        var that = this;

        axios({
                method: 'patch',
                url: url,
                data: data,
                responseType: 'json'
            })
            .then((response) => {
                successCallBack(response)
            }).catch((error) => {
                if (error.response.status != '401') {
                    if (typeof errorCallBack === 'undefined')
                        that.throwErrorCallback(error.response)
                    else
                        errorCallBack(error.response)
                } else {
                    that.unauthorized()
                }
            })
    },
    logout(url,token,successCallBack,errorCallBack){
        window.axios.defaults.headers.common['Authorization'] = `Token ${token}`;
        axios({
            method: 'post',
            url: url,
            data: {},
            responseType: 'json'
        })
        .then((response) => {
            successCallBack(response);
        }).catch((error) => {
            errorCallBack(error);
        })
    }

}

window.sendForm = {
    setAuthorization() {
        let userObj = JSON.parse(localStorage.getItem('homecare_admin_auth'))
        if (userObj != null && userObj.access_token) {
            ajaxR.setRequestHeader('Authorization', 'Token ' + userObj.access_token);
        }
    },
    post(url, form) {
        return new Promise((resolve,reject) => {
            ajaxR.open("POST", Constants.default.APIBASEURL + url);
            ajaxR.addEventListener("load", (res) => {
                if (res.currentTarget.status == 201 || res.currentTarget.status == 200) {
                    resolve(res.data);
                } else {
                    let err = JSON.parse(res.target.response);
                    reject(err);
                }
            });
            this.setAuthorization();
            ajaxR.setRequestHeader('Accept', 'application/json');
            ajaxR.send(form);
        })
    },
    patch(url, form) {
        return new Promise((resolve,reject) => {
            ajaxR.open("PATCH", Constants.default.APIBASEURL + url);
            ajaxR.addEventListener("load", (res) => {
                if (res.currentTarget.status == 201 || res.currentTarget.status == 200) {
                    resolve(res.data);
                } else {
                    let err = JSON.parse(res.target.response);
                    reject(err);
                }
            });
            this.setAuthorization();
            ajaxR.setRequestHeader('Accept', 'application/json');
            ajaxR.send(form);
        })
    }
}